<div class="aihub-payment-request-page"
     [ngStyle]="{'background-image': backgroundImageUrl ? 'url(' + backgroundImageUrl + ')' : null}">
  <div *ngIf="isLoading" class="aihub-payment-request-loading">
    <div class="spinner"></div>
  </div>

  <div *ngIf="!isLoading" class="aihub-payment-request-shell">
    <div class="aihub-payment-request-card">
      <img *ngIf="paymentLogoImageUrl" class="aihub-payment-request-logo" [src]="paymentLogoImageUrl" alt="Logo"/>

      <div *ngIf="isPaymentInProgress" class="aihub-payment-request-invalid" [ngStyle]="bodyTextStyle">
        <h4 [ngStyle]="headingTextStyle">Betaling wordt verwerkt</h4>
        <p>Er wordt al een betaling voor dit betaalverzoek verwerkt.</p>
        <p>Ververs deze pagina later of neem contact op als dit lang blijft duren.</p>
      </div>

      <div *ngIf="!isPaymentValid && !isPaymentInProgress" class="aihub-payment-request-invalid" [ngStyle]="bodyTextStyle">
        <h4 [ngStyle]="headingTextStyle">Betaalverzoek niet beschikbaar</h4>
        <p *ngIf="paymentRequest?.IsCompleted">Dit betaalverzoek is al betaald.</p>
        <p *ngIf="!paymentRequest?.IsCompleted && paymentRequest?.IsExpired">Dit betaalverzoek is verlopen.</p>
        <p *ngIf="!paymentRequest?.IsExpired && !paymentRequest?.IsCompleted">Dit betaalverzoek kan niet meer gebruikt worden.</p>
      </div>

      <div *ngIf="isPaymentValid">
        <div class="aihub-payment-request-details" [ngStyle]="bodyTextStyle">
          <div class="aihub-payment-request-transaction-information-field">
            <span class="aihub-payment-request-transaction-information-field-title">Bedrag:</span>
            <span class="aihub-payment-request-transaction-information-field-value">{{ formatAmount(paymentRequest.Amount) }} {{ paymentRequest.CurrencyCode }}</span>
          </div>
          <div class="aihub-payment-request-transaction-information-field">
            <span class="aihub-payment-request-transaction-information-field-title">Ontvanger:</span>
            <span class="aihub-payment-request-transaction-information-field-value">{{ paymentRequest.CreditorName }}</span>
          </div>
          <div class="aihub-payment-request-transaction-information-field">
            <span class="aihub-payment-request-transaction-information-field-title">Omschrijving:</span>
            <span class="aihub-payment-request-transaction-information-field-value">{{ paymentRequest.Description }}</span>
          </div>
          <div class="aihub-payment-request-transaction-information-field">
            <span class="aihub-payment-request-transaction-information-field-title">Betaaldatum:</span>
            <span class="aihub-payment-request-transaction-information-field-value">{{ formatDate(paymentRequest.CreatedAt) }}</span>
          </div>
          <div class="aihub-payment-request-transaction-information-field">
            <span class="aihub-payment-request-transaction-information-field-title">Transactie ID:</span>
            <span class="aihub-payment-request-transaction-information-field-value">{{ paymentRequest.TransactionId }}</span>
          </div>
        </div>

        <div *ngIf="bankRedirectUrl" class="aihub-payment-request-bank-redirect" [ngStyle]="bodyTextStyle">
          <p>De banklink staat klaar. Klik op de knop hieronder om verder te gaan naar uw bank.</p>
          <button class="aihub-payment-request-submit-button aihub-payment-request-bank-redirect-button"
                  type="button"
                  [ngStyle]="buttonStyle"
                  (click)="continueToBank()">
            Verder naar {{ selectedBankName }}
          </button>
        </div>

        <div *ngIf="!bankRedirectUrl" class="aihub-payment-request-form">
          <label class="aihub-payment-request-field">
            <span class="aihub-payment-request-field-label"
                  [class.raised]="isCountryLabelRaised">Selecteer uw land</span>
            <input class="aihub-payment-request-text-input"
                   type="text"
                   role="combobox"
                   aria-autocomplete="list"
                   aria-label="Selecteer uw land"
                   aria-controls="aihub-payment-request-country-options"
                   [attr.aria-expanded]="shouldShowCountryOptions"
                   [attr.aria-activedescendant]="activeCountryOptionId"
                   [attr.aria-invalid]="hasCountryValidationState && !isCountryValid"
                   [ngModel]="countryInput"
                   (ngModelChange)="onCountryInput($event)"
                   (keydown)="onCountryKeyDown($event)"
                   (focus)="onCountryFocus()"
                   (blur)="closeCountryOptionsAfterDelay()"
                   autocomplete="off"/>
            <span *ngIf="hasCountryValidationState"
                  class="aihub-payment-request-field-validation-icon"
                  [class.correct]="isCountryValid"
                  [class.error]="!isCountryValid"
                  aria-hidden="true">
              {{ isCountryValid ? '✓' : '×' }}
            </span>
            <div *ngIf="shouldShowCountryOptions"
                 id="aihub-payment-request-country-options"
                 class="aihub-payment-request-options"
                 role="listbox"
                 aria-label="Landen">
              <button *ngFor="let country of filteredCountries; let index = index"
                      type="button"
                      class="aihub-payment-request-option"
                      role="option"
                      tabindex="-1"
                      [id]="'aihub-payment-request-country-option-' + index"
                      [class.active]="index === activeCountryIndex"
                      [attr.aria-selected]="index === activeCountryIndex"
                      (mousedown)="selectCountry(country)">
                {{ country.Name }}
              </button>
            </div>
          </label>

          <label class="aihub-payment-request-field">
            <span class="aihub-payment-request-field-label"
                  [class.raised]="isBankLabelRaised">Selecteer uw bank</span>
            <input class="aihub-payment-request-text-input"
                   type="text"
                   role="combobox"
                   aria-autocomplete="list"
                   aria-label="Selecteer uw bank"
                   aria-controls="aihub-payment-request-bank-options"
                   [attr.aria-expanded]="shouldShowBankOptions"
                   [attr.aria-activedescendant]="activeBankOptionId"
                   [attr.aria-invalid]="hasBankValidationState && !isBankValid"
                   [ngModel]="bankInput"
                   (ngModelChange)="onBankInput($event)"
                   (keydown)="onBankKeyDown($event)"
                   (focus)="onBankFocus()"
                   (blur)="closeBankOptionsAfterDelay()"
                   autocomplete="off"
                   [disabled]="!selectedCountry"/>
            <span *ngIf="hasBankValidationState"
                  class="aihub-payment-request-field-validation-icon"
                  [class.correct]="isBankValid"
                  [class.error]="!isBankValid"
                  aria-hidden="true">
              {{ isBankValid ? '✓' : '×' }}
            </span>
            <div *ngIf="shouldShowBankOptions"
                 id="aihub-payment-request-bank-options"
                 class="aihub-payment-request-options"
                 role="listbox"
                 aria-label="Banken">
              <button *ngFor="let bank of filteredBanks; let index = index"
                      type="button"
                      class="aihub-payment-request-option"
                      role="option"
                      tabindex="-1"
                      [id]="'aihub-payment-request-bank-option-' + index"
                      [class.active]="index === activeBankIndex"
                      [attr.aria-selected]="index === activeBankIndex"
                      (mousedown)="selectBank(bank)">
                {{ bank.Name }}
              </button>
            </div>
          </label>

          <label *ngFor="let field of selectedBankAdditionalFields"
                 class="aihub-payment-request-field aihub-payment-request-additional-field"
                 [attr.title]="field.Description || null">
            <span class="aihub-payment-request-field-label"
                  [class.raised]="additionalFieldInputs[field.Name]">
              {{ getAdditionalFieldLabel(field) }}
            </span>
            <input class="aihub-payment-request-text-input"
                   [type]="getAdditionalFieldType(field)"
                   [attr.inputmode]="field.FieldEnum === 'IBAN' ? 'text' : null"
                   [attr.aria-label]="getAdditionalFieldLabel(field)"
                   [attr.aria-invalid]="hasAdditionalFieldValidationState(field) && !isAdditionalFieldValid(field)"
                   [attr.title]="field.Description || null"
                   [(ngModel)]="additionalFieldInputs[field.Name]"
                   autocomplete="off"/>
            <span *ngIf="hasAdditionalFieldValidationState(field)"
                  class="aihub-payment-request-field-validation-icon"
                  [class.correct]="isAdditionalFieldValid(field)"
                  [class.error]="!isAdditionalFieldValid(field)"
                  aria-hidden="true">
              {{ isAdditionalFieldValid(field) ? '✓' : '×' }}
            </span>
          </label>

          <button class="aihub-payment-request-submit-button"
                  type="button"
                  [ngStyle]="buttonStyle"
                  [disabled]="!canStartPayment"
                  [attr.aria-busy]="isStarting"
                  [attr.aria-disabled]="!canStartPayment"
                  (click)="startPayment()">
            {{ isStarting ? 'Moment...' : 'Nu betalen' }}
          </button>

          <p *ngIf="showStartError" class="aihub-payment-request-error">
            Er wordt al een betaling voor dit betaalverzoek verwerkt. Ververs deze pagina later of neem contact op als dit lang blijft duren.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
